import { Model } from '@vuex-orm/core';

export default class FMMatrix extends Model {
  static entity = 'fm_matrix';
  static primaryKey = 'id';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.id;
    /** @type {string | null} */
    this.name_de;
    /** @type {string | null} */
    this.foerderstelle;
    /** @type {string | null} */
    this.foerderstelleid;
    /** @type {string | null} */
    this.zielgruppe_de;
    /** @type {string | null} */
    this.kurzbeschreibung_de;
    /** @type {string | null} */
    this.detailbeschreibung_de;
    /** @type {number | null} */
    this.investitionenvon;
    /** @type {number | null} */
    this.investitionenbis;
    /** @type {any} */
    this.unternehmensgroessen;
    /** @type {any} */
    this.vorhaben;
    /** @type {any} */
    this.foerderarten;
    /** @type {any} */
    this.schwerpunkte;
    /** @type {number | null} */
    this.sortierung;
    /** @type {string | null} */
    this.url;
    /** @type {string | null} */
    this.name_en;
    /** @type {string | null} */
    this.zielgruppe_en;
    /** @type {string | null} */
    this.kurzbeschreibung_en;
    /** @type {string | null} */
    this.detailbeschreibung_en;
  }

  static fields() {
    return {
      id: this.string(''),
      name_de: this.string('').nullable(),
      foerderstelle: this.string('').nullable(),
      foerderstelleid: this.string('').nullable(),
      zielgruppe_de: this.string('').nullable(),
      kurzbeschreibung_de: this.string('').nullable(),
      detailbeschreibung_de: this.string('').nullable(),
      investitionenvon: this.number(0).nullable(),
      investitionenbis: this.number(0).nullable(),
      unternehmensgroessen: this.attr([]).nullable(),
      vorhaben: this.attr([]).nullable(),
      foerderarten: this.attr([]).nullable(),
      schwerpunkte: this.attr([]).nullable(),
      sortierung: this.number(0).nullable(),
      url: this.string('').nullable(),
      name_en: this.string('').nullable(),
      zielgruppe_en: this.string('').nullable(),
      kurzbeschreibung_en: this.string('').nullable(),
      detailbeschreibung_en: this.string('').nullable()
    };
  }
}
